import React from "react";
import { Icon } from "@iconify/react";

const UnitCountOne = ({ dashboardData }) => {
  return (
    <>
      <div className="row row-cols-xxxl-7 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-1 h-100">
            <a href="/renter">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Renters
                    </p>
                    <h6 className="mb-0">{dashboardData?.totalUsers || 0}</h6>
                  </div>
                  <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="gridicons:multiple-users"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <a href="/analytic">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Earning
                    </p>
                    <h6 className="mb-0">
                      ${dashboardData?.totalEarnings || 0}
                    </h6>
                  </div>
                  <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="solar:wallet-bold"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <a href="/booking">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Bookings
                    </p>
                    <h6 className="mb-0">
                      {dashboardData?.totalBookings || 0}
                    </h6>
                  </div>
                  <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="mdi:book-account"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Second row */}
      <div className="row row-cols-xxxl-7 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4 mt-4">
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-5 h-100">
            <a href="/booking">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Pending Bookings
                    </p>
                    <h6 className="mb-0">
                      {dashboardData?.pendingBookings || 0}
                    </h6>
                  </div>
                  <div className="w-50-px h-50-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="mdi:book-account"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-4 h-100">
            <a href="/booking">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Approve Bookings
                    </p>
                    <h6 className="mb-0">
                      {dashboardData?.approvedBookings || 0}
                    </h6>
                  </div>
                  <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="mdi:book-account"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <a href="/supportticket">
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      Total Resolved Tickets
                    </p>
                    <h6 className="mb-0">
                      {dashboardData?.resolvedTickets || 0}
                    </h6>
                  </div>
                  <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                    <Icon
                      icon="mdi:ticket-account"
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitCountOne;
